import { useMutation } from "react-query";
import getRegtankIndOnboardingLink from "../services/getRegtankIndOnboardingLink";

function useGetRegtankIndOnboardingLink() {
  return useMutation(["ind-onboarding-link"], getRegtankIndOnboardingLink);
}

export default useGetRegtankIndOnboardingLink;
